const digest = '6389f534684f634941fbe15199339a5c621296380de3bb68254ed23ba0937fe1';
const css = `body{background-color:#ecedee}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default {  };

export { css, digest };